import { render, staticRenderFns } from "./PasskeysTable.vue?vue&type=template&id=fee97b72"
import script from "./PasskeysTable.vue?vue&type=script&lang=js"
export * from "./PasskeysTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports